
import React from "react";
import PropTypes from 'prop-types';
import CopyToClipboard from "react-copy-to-clipboard";
import './style.scss';


const BarcodeEcommerceItem = ({
    barcodeEcommerce="",
    handleEcomerceItemProcessChange=null,
    handleEcomerceItemValueCopy=null,
    valueBarcode="" }) => {

    
   
    const copyClip=()=>{
        handleEcomerceItemProcessChange(); //send function popup button
        handleEcomerceItemValueCopy(barcodeEcommerce); //send barcode seleted
  
    };


    return (
        <div>
            
           {/* <div className="btn-ecomerce">
                            <a   href="#"  style={{pointerEvents:'none'}}>
                                <span>{barcodeEcommerce}</span>
                            </a>          
            </div>  */}
            <CopyToClipboard text={barcodeEcommerce}>
            <div className="btn-copy" onClick={copyClip}>
          
            <a   href="#"  style={{pointerEvents:'none'}}>
            <i className="fas fa-clipboard icon-copy"></i>
            {valueBarcode==barcodeEcommerce && <i className="fas fa-check-circle icon-copied" ></i>} 
            {barcodeEcommerce}
            
             </a>
            </div>
            </CopyToClipboard>
           
            
        </div>
      )
    }
    
    BarcodeEcommerceItem.propTypes = {
        barcodeEcommerce: PropTypes.string,
        handleEcomerceItemProcessChange:PropTypes.func,
        handleEcomerceItemValueCopy:PropTypes.func,
        valueBarcode:PropTypes.string
        
        
}


export default BarcodeEcommerceItem;
